<script>
export default {
	data (){
		return {
			pending: false,
		}
	},
	async mounted (){
		window.App = this
	},
	methods: {
		async init (){
		},
		logout (){			
			// this.$device.logout()
		},
		checkUnauth (){
			console.log("未鉴权")
			this.logout()
		},
	}
}
</script>
<template lang="pug">
#app
	van-overlay(:show="pending" z-index="9999")
		.center
			van-loading(color="#1989fa" vertical size="24") 正在加载数据...
	router-view
</template>
<style lang="scss">
html,body{
	height:100%;
}
body{
	overscroll-behavior-y: contain;
}
#app {
	height:100%;
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	flex-direction: column;
}

</style>
